export enum AircraftBillingRateType {
  'Hour' = 1,
  'Mile' = 2,
  'Custom Rate 1' = 3,
  'Custom Rate 2' = 4
}
